import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import "./main.css";
// eslint-disable-next-line no-unused-vars
import axios from "./shared/axios-config";
Vue.config.productionTip = false

new Vue({
  vuetify,
  height:'650px',
  router: router,
  render: h => h(App)
}).$mount('#app')
